import { ITableReport } from "./TableInterfaces";

export interface IAddressbook {
  address: string;
  title: string;
  additionalData: string;
  notificationBrokerType: string;
  notificationBrokerTypeStr: string;
  contactType: string;
  contactTypeStr: string;
}
export interface IAddressBookListItem extends IAddressbook, ITableReport {
  id: number;
  lastModify: string;
  lastModifyStr: string;
}

export enum AddressbookContactType {
  Phone,
  Email,
  Telegram,
}

export enum AddressbookNotificationBroker {
  Farabi,
  Sahra,
  Pasargard,
  Pishro,
}
